module.exports = __webpack_public_path__ + "img/icon_primary_menu_dashboard@2x.ff9af904.png";